module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Cif0pL/tc-custom/9781455604340.jpg?1726755951405",
      "alt": "This image is the cover for the book Flags of Civil War North Carolina, Flag Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Flags of Civil War North Carolina, Flag Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("This volume covering North Carolina’s Civil War–era flags tells the story of the Confederate State through its banners of pride, battle, and rebellion.")])]), _c('p', [_vm._v(" Throughout the 1860s, the Confederate State of North Carolina flew scores of flags over its government, cavalry, and navy. Symbolizing the way of life those men sought to protect, these flags provide a unique index to the history of the Civil War in this southern coastal state. ")]), _c('p', [_vm._v(" This comprehensive study of North Carolina’s Civil War–era flags presents a wide-ranging collection of these banners, along with information on their origins and meanings. From the flags of the Guilford Greys to the Buncombe Riflemen, this collection is a fascinating portrait of the state’s ill-fated battle for independence. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Glenn Dedmondt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Glenn Dedmondt spent much of his life in the United States Marine Corps. He has served in, among others, Vietnam; Okinawa; Kaneohe Bay, Hawaii; and Parris Island. He received a bachelor of science degree in elementary education from Southern Missionary College (now Southern Adventist University) in Collegedale, Tennessee. He lives with his wife on a farm in Doniphan, Missouri.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pelican Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0